@if (showModal) {
<app-dialog-title>{{ "create-batch" | transloco }}</app-dialog-title>
<mat-dialog-content class="content">
  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  } @if (bulkActionState !== 'COMPLETED') {
  <div>
    <p>
      Creating a batch will add {{ selectedTaxReturnIds.length }} new
      {{ taxReturnAlias }}{{ selectedTaxReturnIds.length === 1 ? "" : "s" }} to
      the batch
    </p>
    <div class="content">
      <label>{{ "batch-name" | transloco }}</label>
      <input
        [attr.data-test-ref]="'batch-name-input'"
        type="text"
        [formControl]="batchNameInput"
        [(ngModel)]="batchName"
      />
    </div>
  </div>
  } @if (bulkActionState === 'COMPLETED') {
  <div>
    <p>{{ "new-batch-has-been-created" | transloco }}</p>
  </div>
  }
</mat-dialog-content>
@if (bulkActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    class="ui primary button"
    (click)="createBatch()"
    [disabled]="submitButtonDisabled"
    [ngClass]="{ loading: bulkActionState === 'LOADING' }"
  >
    {{ "save" | transloco }}
  </button>
</mat-dialog-actions>
} @if (bulkActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">
    {{ "ok" | transloco }}
  </button>
</mat-dialog-actions>
} }
